module.exports = __webpack_public_path__ + "img/mesa_el_g.aca0f517.png";